export default "__VITE_ASSET__222b3ec8__"